module.exports = __webpack_public_path__ + "img/asus-watch-3.6fae0524.jpg";